/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { OrbitAddressRegistryV2 } from "../OrbitAddressRegistryV2";

export class OrbitAddressRegistryV2__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<OrbitAddressRegistryV2> {
    return super.deploy(overrides || {}) as Promise<OrbitAddressRegistryV2>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): OrbitAddressRegistryV2 {
    return super.attach(address) as OrbitAddressRegistryV2;
  }
  connect(signer: Signer): OrbitAddressRegistryV2__factory {
    return super.connect(signer) as OrbitAddressRegistryV2__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OrbitAddressRegistryV2 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as OrbitAddressRegistryV2;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "collectionRegistry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "marketplace",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orbitAuction",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orbitBundles",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orbitRewardsDistributor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orbitalApes",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenRegistry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_collectionRegistry",
        type: "address",
      },
    ],
    name: "updateCollectionRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_marketplace",
        type: "address",
      },
    ],
    name: "updateMarketplace",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_orbitAuction",
        type: "address",
      },
    ],
    name: "updateOrbitAuction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_orbitBundles",
        type: "address",
      },
    ],
    name: "updateOrbitBundles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_orbitRewardsDistributor",
        type: "address",
      },
    ],
    name: "updateOrbitRewardsDistributor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_orbitalApes",
        type: "address",
      },
    ],
    name: "updateOrbitalApes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenRegistry",
        type: "address",
      },
    ],
    name: "updateTokenRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wEVMOS",
        type: "address",
      },
    ],
    name: "updateWEVMOS",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "wEVMOS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
